/**
 * @generated SignedSource<<b649c02d3aeb97214ef9895c713ab998>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ReaderFragment } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type templateBenefitsRelayFragment$data = {
  readonly benefitsTitle: string | null | undefined;
  readonly templateBenefitContainer: ReadonlyArray<{
    readonly name: string | null | undefined;
    readonly shortDescription: string | null | undefined;
  }> | null | undefined;
  readonly " $fragmentType": "templateBenefitsRelayFragment";
};
export type templateBenefitsRelayFragment$key = {
  readonly " $data"?: templateBenefitsRelayFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"templateBenefitsRelayFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "templateBenefitsRelayFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "benefitsTitle",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ContentPlatformTemplateBenefit",
      "kind": "LinkedField",
      "name": "templateBenefitContainer",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "name",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "shortDescription",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "ContentPlatformTemplateBenefitContainer",
  "abstractKey": null
};

(node as any).hash = "03f54e9ec2683f64ee7161793286e53a";

export default node;
